import "./form-tenant-settings.scss";

import { TenantFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import EditorControl from "@shared/ui/hook-form/editor-control/editor-control";
import EmailContentControl from "@shared/ui/hook-form/email-content-control/email-content-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import { useFormContext } from "react-hook-form";

type InputFormSchema = TenantFormSchema;
export function FormTenantSettings() {
  const { control, watch } = useFormContext<TenantFormSchema>();
  const enableEmailFeature = watch('featureBirthdayEmail');

  return (
    <div id="FormTenantSettings" className="tenant">
      <div>
        <h2>Additional settings:</h2>
        <CheckboxControl<InputFormSchema>
          control={control}
          name="allowUnderEighteen"
          label="Allow under 18 to sign up"
          containerClassName="pb-2"
        />
        <CheckboxControl<InputFormSchema>
          control={control}
          name="allowDecimalPoints"
          label="Include decimal points"
          containerClassName="pb-2"
        />
        <CheckboxControl<InputFormSchema>
          control={control}
          name="featureBirthdayEmail"
          label="Enable Birthday Greeting by Email"
          containerClassName="pb-2"
        />
        {
          enableEmailFeature ? (
            <>
              <InputControl<InputFormSchema>
                control={control}
                name="smtpAppPassword"
                label="SMTP App Password"
                className="w-full md:w-3/4"
                containerClassName="pb-2"
              />
              <InputControl<InputFormSchema>
                control={control}
                name="smtpMailUser"
                label="SMTP User Email"
                className="w-full md:w-3/4"
                containerClassName="pb-2"
              />
              <InputControl<InputFormSchema>
                control={control}
                name="smtpMailFrom"
                label="SMTP Email Subject"
                className="w-full md:w-3/4"
                containerClassName="pb-2"
              />
              <EmailContentControl<InputFormSchema>
                control={control}
                name="smtpMailContent"
                label="Email Content"
                className="w-full md:w-3/4"
                containerClassName="pb-2"
                placeholder="Happy birthday from us!"
              />
            </>
          ) : null
        }
        <EditorControl<InputFormSchema>
          control={control}
          name="termsAndConditions"
          label="Terms and Conditions"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter Terms and Conditions"
        />
        <EditorControl<InputFormSchema>
          control={control}
          name="privacyPolicy"
          label="Privacy Policy"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          placeholder="Enter Privacy Policy"
        />
      </div>
    </div>
  );
}

export default FormTenantSettings;
